import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";
import moment from "moment";
// import { ZegoUIKitPrebuilt } from './ChatCall/zego-uikit-prebuilt.js';
import OneSignal from "react-onesignal";

import ZIM from "zego-zim-web";

export const setZegoDetailsFunction = () => {
  const roomID = "room01";
  const userID = localStorage.getItem("user_name");
  let zp = null;
  if (userID) {
    const userName = userID;
    const appID = 1485872462;
    const serverSecret = "8e9ec2e8a91d24fd83fc68a74bda9f04";
    const TOKEN = ZegoUIKitPrebuilt.generateKitTokenForTest(
      appID,
      serverSecret,
      roomID,
      userID,
      userName
    );
    zp = ZegoUIKitPrebuilt.create(TOKEN);
    zp.addPlugins({ ZIM });
  }
  return zp;
};

export function convertSecondsToTime(seconds) {
  var date = new Date(null);
  date.setSeconds(seconds);
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
}

export const sortArray = (array) => {
  array.sort(function (a, b) {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.
    return new Date(b.timestamp) - new Date(a.timestamp);
  });
};

export const reverseString = (str) => {
  var splitString = str.split("");
  var reverseArray = splitString.reverse(); // var reverseArray = ["h", "e", "l", "l", "o"].reverse();
  var joinArray = reverseArray.join(""); // var joinArray = ["o", "l", "l", "e", "h"].join("");
};
export function getFileTypeFromUrl(url, return_type = "type") {
  let reversedStr = url?.split("/file%2F");
  let val = reversedStr[reversedStr.length - 1]?.split("?")[0];
  let file = val;
  if (return_type === "type") {
    file = val?.split(".")[1];
  }
  return file;
}

// download Excel
export function download_url(url) {
  var element = window.document.createElement("a");
  element.href = url;
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

export const isValidUrl = (urlString) => {
  var inputElement = document.createElement("input");
  inputElement.type = "url";
  inputElement.value = urlString;

  if (!inputElement.checkValidity()) {
    return false;
  } else {
    return true;
  }
};

export function getUrlParams(
  url = window.location.href
) {
  let urlStr = url.split("?")[1];
  return new URLSearchParams(urlStr);
}

export function randomID(len) {
  let result = "";
  if (result) return result;
  var chars = "12345qwertyuiopasdfgh67890jklmnbvcxzMNBVCZXASDQWERTYHGFUIOLKJP",
    maxPos = chars.length,
    i;
  len = len || 5;
  for (i = 0; i < len; i++) {
    result += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return result;
}

// date to string(today)
export function date_range(type) {
  var fromDate = "";
  var toDate = "";
  var today = new Date();
  if (type == "Today") {
    var yesterday = new Date();
    today.setDate(today.getDate());
    var Today = today.toISOString().substr(0, 10);
    yesterday.setDate(yesterday.getDate() - 1);
    var Yesterday = yesterday.toISOString().substr(0, 10);
    fromDate = Today;
    toDate = Yesterday;
  } else if (type == "Weekly") {
    // var today = new Date();
    var last8Days = new Date(today.getTime() - 8 * 24 * 60 * 60 * 1000);
    today.setDate(today.getDate());
    var Today = today.toISOString().substr(0, 10);
    var Last8Days = last8Days.toISOString().substr(0, 10);
    fromDate = Last8Days;
    toDate = Today;
  } else if (type == "Monthly") {
    var Today = today.toISOString().substr(0, 10);
    var thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 31);
    var ThirtyDaysAgo = thirtyDaysAgo.toISOString().substr(0, 10);
    fromDate = ThirtyDaysAgo;
    toDate = Today;
  }
  return [fromDate, toDate];
}

export const setOneSignal = async () => {
  let playerID = localStorage.getItem("onesignal_token");
  if (playerID) return playerID;

  return new Promise((resolve) => {
    const timeout = setTimeout(() => {
      resolve(localStorage.getItem("onesignal_token") || "");
    }, 5000); // 5 second timeout

    try {
      if (!OneSignal) {
        clearTimeout(timeout);
        resolve("");
        return;
      }
      OneSignal.init({
        autoRegister: false,
        appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
        allowLocalhostAsSecureOrigin: process.env.REACT_APP_ONESIGNAL_ALLOW_LOCALHOST === "true",
      }).then(() => {
        OneSignal.getUserId(function (userId) {
          if (userId) {
            localStorage.setItem("onesignal_token", userId);
            playerID = userId;
          }
          clearTimeout(timeout);
          resolve(playerID || "");
        });
        OneSignal.isPushNotificationsEnabled((isEnabled) => {
          if (!isEnabled) {
            OneSignal.showHttpPrompt();
          }
        });
      }).catch(err => {
        console.error("OneSignal init error:", err);
        clearTimeout(timeout);
        resolve(localStorage.getItem("onesignal_token") || "");
      });
    } catch (error) {
      console.error("OneSignal error:", error);
      clearTimeout(timeout);
      resolve(localStorage.getItem("onesignal_token") || "");
    }
  });
};


export function callInvitation(zp, userid) {
  zp.sendCallInvitation({
    callees: [{ userID: userid }],
    callType: 0,
    timeout: 60,
  })
    .then((res) => {
      console.warn(res);
    })
    .catch((err) => {
      console.warn(err);
    });
}
